<template>
  <div class="modal-container">
    <slot name="button" :open="open"></slot>

    <div
      v-on:mousemove.prevent.stop
      v-if="showModal"
      v-on:click="close"
      :class="['modal', modalClass, 'd-flex']"
    >
      <div class="container" v-on:click.stop>
        <inline-svg
          v-on:click="close"
          :src="$icon('times_circle.svg')"
          class="icon medium cursor-pointer pull-right black-icon"
        ></inline-svg>

        <slot name="form" :close="close" :closeAfterSubmit="closeAfterSubmit"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg';

export default {
  props: {
    modalClass: String,
  },
  data: function () {
    return {
      showModal: Boolean,
    };
  },

  mounted: function () {
    this.showModal = false;
  },

  methods: {
    close() {
      this.showModal = false;
    },

    open() {
      this.showModal = true;
    },

    // For a <form @submit> inside the modal: closing right away removes the form from the DOM
    // (v-if) before the browser starts the submission, which then silently never happens.
    closeAfterSubmit() {
      setTimeout(this.close);
    },
  },

  components: { InlineSvg },
};
</script>
